import { DropdownMenu } from '../../form';
import TooltipIcon from '../../InfoTooltip/Tooltip-icon';
import { LimitedNavPropsModel } from './limited-nav-props.model';
import { Link } from 'react-router-dom';
import { LANGUAGES } from '../../../constants/lists';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { Icon } from '../../UI';
import { logger } from '../../../helpers/logger';

const LimitedNav = (props: LimitedNavPropsModel) => {
  const { t } = useTranslation();

  const handleTooltipIconClick = () => {
    if (props.onTooltipIconClick) {
      props.onTooltipIconClick();
    }
  };

  const whiteLimitedNavClassname =
    'border-b border-opacity-50 border-grey-30 bg-white shadow-md';

  return (
    <div
      className={`relative md:fixed top-0 flex w-full h-18 min-h-18 px-4 items-center justify-between z-70 mb-0 ${
        props.variant === 'white' && whiteLimitedNavClassname
      } ${props.className || ''}`}
    >
      <Link to={'/'}>
        <Icon
          svgName="merlinLogo"
          color={props.variant === 'white' ? 'black' : 'lime'}
        />
      </Link>
      {props.showLanguageDropdown && (
        <DropdownMenu
          dropdownClassName=""
          dropdownIconClassName="justify-end"
          dropdownTooltipClassName="bg-white border-solid border-grey-10 border shadow-md"
          dropdownItems={LANGUAGES.map(
            (language) => t('language.' + language.code) as string
          )}
          dropdownItemsData={LANGUAGES.map((language) => language.code)}
          dropdownArrowClassName={`-left-1 ${
            props.variant === 'white' ? 'text-black' : 'text-white'
          }`}
          showArrow
          handleClick={(lang, code) => {
            i18n.changeLanguage(code).then((res) => {
              logger.log('Switch language:', code);
            });
          }}
        >
          <span
            className={`text-base text-md ${
              props.variant === 'white' ? 'text-black' : 'text-white'
            }`}
          >
            {t('language.' + LANGUAGES[0].code)}
          </span>
        </DropdownMenu>
      )}
      {props.showTooltipIcon && (
        <div className="flex justify-center items-center w-20 h-full -mr-5">
          <TooltipIcon
            tooltipIconClassname="z-60"
            tooltipIconColor={props.variant === 'white' ? 'black' : 'primary'}
            onClick={handleTooltipIconClick}
          />
        </div>
      )}
      {props.showCloseButton && (
        <div
          className="flex items-center justify-center w-5 h-5 cursor-pointer"
          onClick={() => {
            if (props.onCloseButtonClick) {
              props.onCloseButtonClick();
            }
          }}
        >
          <span className="material-icons text-xl text-primary">close</span>
        </div>
      )}
    </div>
  );
};

export default LimitedNav;
